import dayjs from 'lib/dayjs';
import { DurationUnitType } from 'dayjs/plugin/duration';

/**
 *
 * @param value
 */
export const durationFormat = (value: number, unit: DurationUnitType = 'seconds') => {
  const duration = dayjs.duration(value, unit);
  const h = duration.hours();
  const m = duration.minutes();
  const s = duration.seconds();
  let result = '';
  if (h > 0) {
    result += `${h}h`;
  }
  if (m > 0) {
    result += `${m}m`;
  }
  if (s > 0) {
    result += `${s}s`;
  }
  return result;
};
